import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "94vh",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff",
    fontWeight: "500",
  },
  closeIcon: {
    color: "#fff",
  },
  closeBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#e5e5e5",
      textTransform: "capitalize",
      color: "#000",
      borderRadius: 20,
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "#e5e5e5",
      },
    },
  },
  avatarContainer: {
    paddingBlockEnd: 12,
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "center",
    "& .MuiAvatar-root": {
      width: 64,
      height: 64,
    },
  },
  name: {
    "& .MuiTypography-root": {
      fontWeight: 600,
    },
  },
  detailsContainer: {
    paddingBlockEnd: 12,
  },
  detailsWrapper: {
    display: "flex",
    paddingBlock: 4,
  },
  key: {
    "& .MuiTypography-root": {
      width: 220,
    },
  },
  value: {
    "& .MuiTypography-root": {
      color: "#7a7272",
    },
  },
  wrapper: {
    paddingBlockEnd: 12,
  },
  container: {
    boxShadow: "0px 5px 15px 5px rgb(0 0 0 / 10%)",
    padding: 20,
    borderRadius: 15,
    marginBlockEnd: 20,
    width: "100%",
  },
  label: {
    "& .MuiTypography-root": {
      color: "#d45a00",
    },
  },
  tabWrapper: {
    paddingBlock: 8,
    "& .MuiTab-root": {
      marginInlineEnd: 20,
      textTransform: "capitalize",
      padding: "12px 16px 12px 0px",
      fontSize: 16,
      fontWeight: 500,
      transition: "all ease .3s",
    },
    "& .MuiTabs-indicator": {
      height: 0,
    },
  },
  tableContainer: {
    paddingBlock: 20,
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      textTransform: "uppercase",
      //   fontSize: 16,
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 6,
      },
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 14,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 14,
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  header: {
    "& .MuiTypography-root": {
      fontSize: 20,
      paddingBlockEnd: 12,
      textTransform: "capitalize",
      color: theme.palette.custom.main,
    },
  },

  fieldContainerWrapper: {
    padding: "30px 0px",
  },
  fieldContainer: {
    paddingBottom: "20px",
    paddingRight: "10px",
  },
  updateBtn: {
    padding: "10px 0px",
  },
  mapContainerStyles: {
  paddingTop: "30px",
  paddingBottom: "10px",
  width: "100%",
  height: "500px",
  position: "relative",
  cursor: "crosshair",

  /* 🔥 Drawing Manager buttons (REAL selector) */
  "& .gmnoprint[role='menubar'] button[aria-label='Draw a shape']": {
    transform: "scale(1.6)",
    transformOrigin: "center",
  },
  "& .gmnoprint[role='menubar'] button[aria-label='Stop drawing']": {
  transform: "scale(1.6)",
},
"& .gmnoprint[role='menubar'] > div": {
  marginRight: "12px",
},
},
}));

export default useStyles;
